var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.01a1 1 0 011 1v6c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2v-6a1 1 0 112 0v6h20v-6a1 1 0 011-1zM12 0c.317 0 .6.147.783.377l4.923 4.915a.999.999 0 11-1.412 1.416L13 3.42V17a1 1 0 11-2 0V3.42L7.706 6.708a1 1 0 01-1.32.081l-.094-.083a.999.999 0 01.002-1.414L11.214.38A.998.998 0 0112 0z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconUpload;